import { Box, Typography, Image, MediaBox } from "@jewlr/storybook/core"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"
import { showHolidayRma, holidayRmaDates } from "helpers/holiday"

import { TextColored } from "./components"

const FreeWarrantyContainer = styled(Box).attrs({
  alignItems: "center",
  display: { _: "block", tablet: "flex" },
  flexWrap: "wrap",
  gutter: { tablet: 1 },
  justifyContent: "space-between",
  margin: "auto",
  maxWidth: "1024px",
})``

const HolidayRmaBox = styled(Box)`
  background-color: white;
  border: 1px solid red;
  border-radius: 15px;
  font-weight: 400;
  letter-spacing: -0.02em;
  line-height: 22px;
  margin: 0 16px 24px;
  padding: 24px 32px;

  ${(props) => props.theme.mediaQueries.tablet`
    margin:0 45px 48px 45px;
  `}
`

const Paragraph = styled(Typography).attrs((props) => ({
  mb: 2,
  ...props,
}))``

const FreeWarranty = () => (
  <Box contain>
    {showHolidayRma() && (
      <HolidayRmaBox>
        In order to focus on customer orders and ensure all gifts arrive for the
        holidays, we will not be processing repairs or returns between{" "}
        {holidayRmaDates.start} and {holidayRmaDates.end}. Don&apos;t worry
        &ndash; you&apos;re still covered! We will adjust or extend your repair
        or return deadline accordingly. Thank you for your understanding and
        cooperation during this busy time.
      </HolidayRmaBox>
    )}
    <FreeWarrantyContainer>
      <Box flex={1} textAlign={{ _: "center", tablet: "right" }}>
        <MediaBox greaterThanOrEqual="tablet">
          <Image
            alt="Warranty & Protection"
            src={`${sl.config.jewlr_asset_url}images/info/warranty/jewlr4_${
              sl.config.enable_watches ? "watch_and_ring_box" : "ring_box"
            }.png`}
            style={{ margin: "auto" }}
            width="90%"
          />
        </MediaBox>
      </Box>
      <Box flex={1} textAlign={{ _: "center", tablet: "left" }}>
        <Box px={{ _: 2, tablet: 5 }}>
          <Typography bold fontSize={18} mb={2}>
            FREE Warranty With Purchase
          </Typography>
          <Paragraph>
            We offer a free one-year warranty on all {jewlr_t("terms.jewelry")}{" "}
            purchases against manufacturing defects and workmanship.
          </Paragraph>
          <Paragraph>
            Our Luxury Bridal Collection diamond engagement rings also includes
            a free lifetime manufacturer&apos;s warranty.
          </Paragraph>
          {sl.config.enable_watches && (
            <Paragraph>
              {jewlr_t("terms.Personalized")} Watches include a free 1-year
              warranty that covers manufacturer defects in the workmanship and
              material, including movement mechanisms.
            </Paragraph>
          )}

          <Paragraph mb={{ _: 6, tablet: 2 }}>
            If you need assistance, please use our{" "}
            <TextColored as={Link} data-lc="free-warranty" to="/order/repair">
              Request Repair Form
            </TextColored>
            , or contact our customer service team at{" "}
            <TextColored
              as="a"
              href={`tel:${sl.config.customer_service_toll_free}}`}
            >
              {sl.config.customer_service_toll_free}
            </TextColored>{" "}
            or{" "}
            <TextColored
              as="a"
              href={`mailto:${sl.config.customer_service_email}`}
            >
              {sl.config.customer_service_email}
            </TextColored>{" "}
            with your order number, and we will be happy to assist you.
          </Paragraph>
        </Box>
      </Box>
    </FreeWarrantyContainer>
  </Box>
)

export default FreeWarranty
